import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { EntregaOcurreEdit } from "./componentes/edit"
import { EntregaOcurre as EntregaOcurreComp } from "./pantalla";

export class EntregaOcurre extends React.Component<{match: match<{}>}> {
    render() {
       const path = this.props.match.url;
        return (
            <div>
                <Route exact path={path}  component={EntregaOcurreComp} />
                <Route path={path + "/:id"}  component={EntregaOcurreEdit} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/index.tsx